/**
 * Logo - Pixel art renderer for the plR logo
 */

// Logo pixel grid (24 wide x 16 tall)
// Using 1 for filled, 0 for empty
const LOGO_PIXELS: number[][] = [
  // Row 0
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
  // Row 1 - top of p bowl and R
  [0,0,1,1,1,0,0,0,0,0,0,0,0,0,1,1,1,1,1,0,0,0,0,0],
  // Row 2
  [0,1,1,0,1,1,0,0,0,0,0,0,0,1,1,0,0,0,1,1,0,0,0,0],
  // Row 3
  [0,1,1,0,0,1,1,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,0],
  // Row 4 - middle of p, l stem, R middle
  [0,1,1,0,0,1,1,0,1,1,0,0,0,1,1,0,0,1,1,0,0,0,0,0],
  // Row 5
  [0,1,1,0,1,1,0,0,1,1,0,0,0,1,1,1,1,1,0,0,0,0,0,0],
  // Row 6 - p bowl closes
  [0,0,1,1,1,0,0,0,1,1,0,0,0,1,1,0,1,1,0,0,0,0,0,0],
  // Row 7
  [0,1,1,0,0,0,0,0,1,1,0,0,0,1,1,0,0,1,1,0,0,0,0,0],
  // Row 8 - p stem continues
  [0,1,1,0,0,0,0,0,1,1,0,0,0,1,1,0,0,0,1,1,0,0,0,0],
  // Row 9
  [0,1,1,0,0,0,0,0,1,1,0,0,0,1,1,0,0,0,0,1,1,0,0,0],
  // Row 10
  [0,1,1,0,0,0,0,0,1,1,0,0,0,1,1,0,0,0,0,0,1,1,0,0],
  // Row 11
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],
];

/**
 * Render the plR logo at the specified position
 * @param ctx Canvas context
 * @param x Center X position
 * @param y Top Y position
 * @param scale Pixel scale (default 3)
 * @param color Logo color (default game teal)
 */
export function renderLogo(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  scale: number = 3,
  color: string = '#4ecca3'
): void {
  const firstRow = LOGO_PIXELS[0];
  if (!firstRow) return;

  const width = firstRow.length;
  const height = LOGO_PIXELS.length;
  const totalWidth = width * scale;
  const startX = x - totalWidth / 2;

  ctx.fillStyle = color;

  for (let row = 0; row < height; row++) {
    const rowData = LOGO_PIXELS[row];
    if (!rowData) continue;
    for (let col = 0; col < width; col++) {
      if (rowData[col] === 1) {
        ctx.fillRect(
          startX + col * scale,
          y + row * scale,
          scale,
          scale
        );
      }
    }
  }
}

/**
 * Get the dimensions of the logo at a given scale
 */
export function getLogoDimensions(scale: number = 3): { width: number; height: number } {
  const firstRow = LOGO_PIXELS[0];
  return {
    width: (firstRow?.length ?? 24) * scale,
    height: LOGO_PIXELS.length * scale
  };
}
